import { connect } from 'react-redux';
import { debounce } from 'lodash';

import {
  getIsWhitelabel,
  searchTypeSelector,
  getIsHotelOnly,
  getIsMobile,
  getAppName,
} from 'src/store/view/selectors';

import { cigaretteValuesSelector } from 'src/routes/Hotel/store/selectors/cigaretteValues';
import { convertServerDateToClientDate } from 'src/utils/dateUtils';
import { getSearchParamsStartDate } from 'src/store/enqueue/selectors';
import Searcher from '../../components/Searcher';
import { getDatesWithPricesByFilter } from '../../store/selectors/datesWithPricesByFilter';
import {
  getSearcherFetching,
  getSearcherCarouselDate,
  getSearcherStartDate,
  getSearcherAdults,
  getSearcherKidsAges,
  getSearcherDeparture,
  getSearcherInstantConfirm,
  getHasOffersForCurrentDate,
  getHasOffersInstantConfirm,
  getActiveFilters,
  getIsOpenFiltersList,
} from '../../store/selectors/searcher';
import {
  setSearcherCarouselDateAction,
  toggleInstantConfirmAction,
  searchPriceForDateAction,
  setSearcherFiltersAction,
  setSearcherParamsAction,
} from '../../store/actions/searcher';
import { setSearchTypeAction } from '../../store/actions/view';

import { getSearcherDepartures } from '../../store/selectors/departures';
import { getFilters, getFiltersHotel } from '../../store/selectors/common';

const mapStateToProps = (state) => ({
  dates: getDatesWithPricesByFilter(state),
  isMobile: getIsMobile(state),
  fetching: getSearcherFetching(state),
  adults: getSearcherAdults(state),
  kids: getSearcherKidsAges(state),
  date: getSearcherStartDate(state),
  startDate: convertServerDateToClientDate(getSearchParamsStartDate(state)),
  carouselDate: getSearcherCarouselDate(state),
  departure: getSearcherDeparture(state),
  departures: getSearcherDepartures(state),
  instantConfirm: getSearcherInstantConfirm(state),
  hideFilters: !getHasOffersForCurrentDate(state),
  disableInstantConfirm: getHasOffersInstantConfirm(state),
  addServicesFilters: getIsHotelOnly(state)
    ? getFiltersHotel(state)
    : getFilters(state),
  activeFilters: getActiveFilters(state),
  searchType: searchTypeSelector(state),
  isHotelOnly: getIsHotelOnly(state),
  isWhitelabel: getIsWhitelabel(state),
  appName: getAppName(state),
  cigaretteValues: cigaretteValuesSelector(state),
  isOpenFiltersList: getIsOpenFiltersList(state),
});

const mapDispatchToProps = (dispatch) => ({
  onChangeCarouselDate: (date) =>
    dispatch(setSearcherCarouselDateAction({ date, loadData: true })),
  onPriceDemand: (value) => dispatch(searchPriceForDateAction(value)),
  onChangeInstantConfirm: () => dispatch(toggleInstantConfirmAction()),
  onSubmitFilters: (value) => dispatch(setSearcherFiltersAction(value)),
  setSearchType: (searchType) => dispatch(setSearchTypeAction(searchType)),
  onSubmitSearch: (params) => dispatch(setSearcherParamsAction(params)),
});

const mergeProps = (
  stateProps,
  { onChangeCarouselDate, ...dispatchProps },
) => ({
  ...stateProps,
  ...dispatchProps,
  onChangeCarouselDate: stateProps.isMobile
    ? debounce(onChangeCarouselDate, 500)
    : onChangeCarouselDate,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(Searcher);
